<template>
  <div class="text-line">
    <span class="label">{{ label }}：</span>
    <span class="value" :style="{ color }">{{ valueText }}</span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, null, undefined],
      default: ''
    },
    formatter: {
      type: [Function, Object, null, undefined],
      default: null
    },
    decorator: {
      type: [Function, Object, null, undefined],
      default: null
    }
  },
  computed: {
    valueText() {
      try {
        if (this.formatter) return this.formatter(this.value);
        return `${this.value}` || '--';
      } catch (error) {
        console.log(`CWAMod 页面详情${this.label}值格式化错误：`, error);
      }
      return '--';
    },
    color() {
      if (!this.decorator) return 'inherit';
      return this.decorator(this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.text-line {
  line-height: 22px;
  color: #00a0e9;
}
</style>
